const E = {
  NoTemplates: 'There are currently no templates available.',
  NewTemplate1: "If you'd like to create a new template, please click",
  NewTemplate2: 'New Template',
  NoResults: 'We couldn’t find any templates that match your search criteria.',
  NoResultsBody: 'Please double check your search criteria or try a broader search. If you need assistance, please contact your Bureau Veritas representative.',
  'Pinned Templates': 'Pinned Templates',
  'My Templates': 'My Templates',
  'All Templates': 'All Templates',
  'Project #': 'Project #',
  'Site Location': 'Site Location',
  'PO #': 'PO #',
  'Site #': 'Site #',
  CreatedBy: 'Created By',
  CreatedOn: 'Created On',
  moreValues: 'Click the "More Values" circle plus icon to enter additional sample information. A blue icon will indicate that at least one of these fields must be completed before submitting a job.',
};

const F = {
  NoTemplates: 'Aucun modèle disponible pour le moment.',
  NewTemplate1: 'Pour créer un nouveau modèle, cliquez sur',
  NewTemplate2: 'Nouveau modèle',
  NoResults: 'Aucun modèle ne correspond aux critères de recherche.',
  NoResultsBody: 'Veuillez vérifier les critères de recherche ou les élargir. Si vous avez besoin d’aide, veuillez contacter votre représentant des Lab BV.',
  'Pinned Templates': 'Modèles épinglés',
  'My Templates': 'Mes modèles',
  'All Templates': 'Tous les modèles',
  'Project #': 'No de projet',
  'Site Location': 'Emplacement du site',
  'PO #': 'No de PO',
  'Site #': 'No de site',
  CreatedBy: 'Créé par',
  CreatedOn: 'Créé le',
  moreValues: 'Cliquez sur Afficher plus (bouton rond avec un plus) pour ajouter d’autres échantillons. Un icône bleu indique qu’au moins un champ doit être rempli avant d’envoyer le dossier.',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/templates.js